import React, { Component } from 'react';

import { connect } from 'react-redux';
import { history } from './_helpers/history';
import { alertActions } from './_actions/alert.actions';
import { Switch, Route, Router, Redirect } from 'react-router-dom';

import PublicRoute from './_helpers/public.route.js';
import AuthorizedRoute from './_helpers/authorized.route.js';

import AppLayout from './_layouts/App/'
import LoginLayout from './_layouts/Login/'
import SetupLayout from './_layouts/Setup';
import ContainerFluid from './_layouts/ContainerFluid/';
import AccountLayout from './_layouts/Account';

import Forms from './_pages/Forms/';
import Video from './_pages/Telehealth/Video';
import Events from './_pages/Events/';
import Intake from './_pages/Intake/';
import NotFound from './_pages/NotFound';
import Messages from './_pages/Messages';
import Dashboard from './_pages/Dashboard/';
import Telehealth from './_pages/Telehealth/';
import UserSettings from './_pages/Settings/User';
import LoginRefresh from './_pages/Login/Refresh';
import VaccineModule from './_pages/Vaccine/';
import TutorialsPage from './_pages/Help/Tutorials/';
import ResetPassword from './_pages/Forgot/ResetPassword';
import ForgotPassword from './_pages/Forgot/ForgotPassword';
import Questionnaires from './_pages/Questionnaires/'
import LoginComponent from './_pages/Login/';
import QuestionLibrary from './_pages/QuestionLibrary/'

import UserSetup from './_pages/User/Setup';
import UserConfirm from './_pages/User/Confirm';

import Account from './_pages/Account/';

import LandingPageAdminEdit from './_pages/Account/ManageLandings/Edit'
import LandingPageAdminSetup from './_pages/Account/ManageLandings/Setup'
import LandingPageEdit from './_pages/Account/Users/View/LandingPage/Edit';
import LandingPageSetup from './_pages/Account/Users/View/LandingPage/Setup';
import LicensedUserLandingPage from './_pages/Account/Users/View/LandingPage';

class App extends Component {
  constructor(props) {
    super(props);

    this.unlisten = history.listen((location, action) => {
      props.dispatch(alertActions.clear())
    });
  }

  componentWillUnmount() {
    this.unlisten()
  }

  render() {
    return (
      <Router history={history}>
        <Switch>

          <AuthorizedRoute path='/settings/user/landing' layout={AppLayout} component={LicensedUserLandingPage} />

          <AuthorizedRoute path={`/telehealths/:id/video`} layout={ContainerFluid} component={Video} />

          <AuthorizedRoute path="/messages" layout={AppLayout} component={Messages} />

          <AuthorizedRoute path="/telehealth" layout={AppLayout} component={Telehealth} />

          <AuthorizedRoute path="/forms" layout={AppLayout} component={Forms} />

          <AuthorizedRoute path="/events" layout={AppLayout} component={Events} />

          <AuthorizedRoute path="/questionnaires" layout={AppLayout} component={Questionnaires} />
          <AuthorizedRoute path="/questions" layout={AppLayout} component={QuestionLibrary} />

          <AuthorizedRoute path="/intake" layout={AppLayout} component={Intake} />

          {/* <AuthorizedRoute path="/settings/account/landing/:id/edit" layout={AppLayout} component={LandingPageAdminEdit} />
          <AuthorizedRoute path="/settings/account/landing/setup" layout={AppLayout} component={LandingPageAdminSetup} /> */}

          {/* Account  */}
          <AuthorizedRoute path="/account" layout={AccountLayout} component={Account} />

          {/* Settings */}
          <AuthorizedRoute path="/settings/user" layout={AppLayout} component={UserSettings} />

          <AuthorizedRoute path="/landing/setup" layout={AppLayout} component={LandingPageAdminSetup} />
          <AuthorizedRoute path="/landing/:id/edit" layout={AppLayout} component={LandingPageAdminEdit} />

          <AuthorizedRoute path="/tutorials" layout={AppLayout} component={TutorialsPage} />

          <AuthorizedRoute path="/dashboard" layout={AppLayout} component={Dashboard} />

          <AuthorizedRoute path="/vaccine" layout={AppLayout} component={VaccineModule} />

          {/* User Setup */}
          <PublicRoute path="/user/:token/setup" layout={SetupLayout} component={UserSetup} />
          <PublicRoute path="/user/:token/confirm" layout={SetupLayout} component={UserConfirm} />

          <PublicRoute path="/reset-password/:token" layout={LoginLayout} component={ResetPassword} />
          <PublicRoute path="/forgot-password" layout={LoginLayout} component={ForgotPassword} />
          <PublicRoute path="/login/refresh" layout={LoginLayout} component={LoginRefresh} />
          <PublicRoute path="/login" layout={LoginLayout} component={LoginComponent} />

          <PublicRoute exact path="/">
            <Redirect to="/dashboard" />
          </PublicRoute>

          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps)(App);